import { Link } from 'react-router';
import type { Period } from '@/entities/types';
import { toFullDayDateString } from '@/utils/datetime';
import {
  formatQuarterPart,
  formatWeekPart,
  formatYearPart,
} from '@/utils/format-datetime';

function PeriodBreadcrumb({ label, path }: { label: string; path: string }) {
  return (
    <Link to={path} className="font-light underline decoration-dotted hover:text-gray-500">
      {label}
    </Link>
  );
}

interface PeriodBreadcrumbsProps {
  period: Period;
  targetAt: Date;
}

export function PeriodBreadcrumbs({
  period,
  targetAt,
}: PeriodBreadcrumbsProps) {
  if (period === 'year') {
    return (
      <div aria-hidden="true">
        <span className="invisible font-light">placeholder</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1">
      <PeriodBreadcrumb
        label={formatYearPart(targetAt)}
        path={`/year/${toFullDayDateString(targetAt)}`}
      />
      {['week', 'day'].includes(period) && (
        <>
          <span className="text-xs text-gray-400">/</span>
          <PeriodBreadcrumb
            label={formatQuarterPart(targetAt)}
            path={`/quarter/${toFullDayDateString(targetAt)}`}
          />
        </>
      )}
      {period === 'day' && (
        <>
          <span className="text-xs text-gray-400">/</span>
          <PeriodBreadcrumb
            label={formatWeekPart(targetAt)}
            path={`/week/${toFullDayDateString(targetAt)}`}
          />
        </>
      )}
    </div>
  );
}
